import { OnboardingStatus } from '~/utils/constant';
import type { CompanyStatusDto } from '~/swagger/Api';

export enum routes {
  businessInfo = 'business-information',
  phoneNumber = 'phone-selection',
  paymentAccount = 'payment-setup',
  bankAccount = 'bank-account-setup',
  invoiceSettings = 'invoice-configuration',
  connectedStripe = 'stripe-integration',
  connectedPlaid = 'plaid-integration',
  receivePaymentAccount = 'payment-receiving-setup',

  importing = 'data-importing',
  goLive = 'go-live',
}

export enum BusinessInfomationStep {
  COMPANY_ADDRESS = 'company-address',
  SELECT_BUSINESS_TYPE = 'select-business-type',
  BUSINESS_INFORMATION = 'business-information',
  BUSINESS_DOCUMENTS = 'business-documents',
  PRINCIPAL_INFORMATION = 'principal-information',
  PRINCIPAL_DOCUMENTS = 'principal-documents',
  PERSONAL_INFORMATION = 'personal-information',
  PERSONAL_DOCUMENTS = 'personal-documents',
}

export enum AiKeys {
  WELCOME = 'welcome',
  PHONE = 'phone',
  PAYMENT_SETUP = 'payment-setup',
  BANK_ACCOUNT_SETUP = 'bank-account-setup',
  STRIPE_INTEGRATION = 'stripe-integration',
  PLAID_INTEGRATION = 'plaid-integration',
  DATA_IMPORTING = 'data-importing',
  GO_LIVE = 'go-live',
}

type StepTypeMapping = {
  [K in BusinessInfomationStep]: string;
} & {
  [K in AiKeys]: string;
};

export const onboardingAIChatMapping: StepTypeMapping = {
  [AiKeys.WELCOME]: '0000-welcome',

  [BusinessInfomationStep.COMPANY_ADDRESS]: '0001-company-address',
  [BusinessInfomationStep.SELECT_BUSINESS_TYPE]: '0002-business-type',
  [BusinessInfomationStep.BUSINESS_INFORMATION]: '0003-01-01-buisness-info',
  [BusinessInfomationStep.BUSINESS_DOCUMENTS]: '0003-01-02-buisness-docs',
  [BusinessInfomationStep.PRINCIPAL_INFORMATION]: '0003-01-03-principals',
  [BusinessInfomationStep.PRINCIPAL_DOCUMENTS]: '0003-01-03-principals',
  [BusinessInfomationStep.PERSONAL_INFORMATION]: '0003-02-01-personal-info',
  [BusinessInfomationStep.PERSONAL_DOCUMENTS]: '0003-02-02-personal-docs',

  [AiKeys.PHONE]: '0004-phone',
  [AiKeys.PAYMENT_SETUP]: '0005-payment-setup',
  [AiKeys.BANK_ACCOUNT_SETUP]: '0006-bank-account-setup',
  [AiKeys.STRIPE_INTEGRATION]: '0007-stripe-integration',
  [AiKeys.PLAID_INTEGRATION]: '0008-plaid-integration',
  [AiKeys.DATA_IMPORTING]: '0009-data-importing',
  [AiKeys.GO_LIVE]: '0010-go-live',
};

export type AIChatKey = (typeof onboardingAIChatMapping)[keyof typeof onboardingAIChatMapping];

type StatusProgressMap = {
  [key in OnboardingStatus | 'DEFAULT']: number;
};

export const STATUS_PROGRESS_MAP: StatusProgressMap = {
  [OnboardingStatus.PAID]: 100,
  [OnboardingStatus.IMPORTING]: 80,
  [OnboardingStatus.GET_VERIFIED_CHECKLIST]: 0,
  [OnboardingStatus.USER_HIDE_ONBOARDING]: 100,
  DEFAULT: 0,
} as const;

export const VERIFICATION_STEPS: { statusKey: keyof CompanyStatusDto; progress: number; route: string | (() => string) }[] = [
  {
    statusKey: 'businessInfoSubmitted',
    progress: 10,
    route: () => `${routes.businessInfo}?step=${BusinessInfomationStep.COMPANY_ADDRESS}`,
  },
  {
    statusKey: 'phoneNumberSettled',
    progress: 20,
    route: routes.phoneNumber,
  },
  {
    statusKey: 'invoiceSettingsConfigured',
    progress: 30,
    route: routes.paymentAccount,
  },
  {
    statusKey: 'hasBankAccounts',
    progress: 40,
    route: routes.bankAccount,
  },
  {
    statusKey: 'stripeConnected',
    progress: 50,
    route: routes.connectedStripe,
  },
  {
    statusKey: 'plaidConnected',
    progress: 60,
    route: routes.connectedPlaid,
  },
];
